<template>
  <div class="statistic">
    <div class="statistic__title">
      {{$t('feed.analytics.statistics.title')}}
    </div>

    <el-card shadow="hover" class="statistic__card">
      <statistic-header chart-name="Statistic"/>

      <template v-if="!dataEmpty">
        <statistic-body
          :data="data"
          chart-name="Statistic"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.statistics.noData')}}.
      </template>

    </el-card>

    <div class="statistic__divider"></div>
  </div>
</template>

<script>
  /*
    Компонент статистики
    родительский Common
  */
// components
import StatisticHeader from "./header/StatisticHeader";
import StatisticBody from "./body/StatisticBody";

// mixins
import { analytics } from "../../../../../../../mixins/analytics";

export default {
  name: "Statistic",
  data() {
    return {
      name: "Statistic"
    };
  },
  mixins: [
    analytics
  ],
  components: {
    StatisticHeader,
    StatisticBody
  }
};
</script>

<style>
.statistic__title {
  margin-bottom: 20px;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  color: #5E6D82;
}

.statistic__card {
  margin-bottom: 20px;
}

.statistic__divider {
  border: 1px solid rgba(229, 229, 229, 0.5);
  margin-bottom: 33px;
}
@media screen and (max-width: 480px) {
  .statistic__card {
    overflow-x: auto;
  }
}
</style>
